import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";

import ButtonFilters from '../filters/ButtonFilters';

function ConnectedActionFilters({ active, onClick, onClear, className, showClearFilters = false, isReady }) {
  return <ButtonFilters
    className={className}
    active={active}
    onClick={isReady ? onClick : null}
    onClear={onClear}
    showClear={showClearFilters}
  />
}

ConnectedActionFilters.propTypes = {
  active: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  className: PropTypes.string
}

const ActionFilters = connect(
  state => ({
    isReady: state.isReadyBoostFilters, // To let the list completely load before filtering (Only Boost ON)
    showClearFilters: state.showClearFilters,
  }),
)(ConnectedActionFilters);

export default ActionFilters;
